import * as React from 'react';
import { SubwayInfo as SubwayInfoComponent } from '../../components/SubwayInfo';
import { SubwayColor } from '../../components/SubwayColor';

interface ISubwayInfoProps {
  title?: string | null;
  color?: string | null;
  timeToSubway?: string | null;
}

export function SubwayInfo({ color, title, timeToSubway }: ISubwayInfoProps) {
  if (!title) {
    return null;
  }

  return (
    <SubwayInfoComponent
      title={title}
      color={color ? <SubwayColor color={color} /> : null}
      timeToSubway={timeToSubway || null}
    />
  );
}
